import { render, staticRenderFns } from "./MaterialsOverview.vue?vue&type=template&id=2f925f88"
import script from "./MaterialsOverview.vue?vue&type=script&lang=js"
export * from "./MaterialsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports